import { configureStore } from '@reduxjs/toolkit';
import dashboardReducer from './appSlice';
import authenticationReducer from './authenticationSlice';
import userReducer from './userSlice';

const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    authentication: authenticationReducer,
    user: userReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
